import React from 'react';
import { Container, Section } from '../ui/Section';
import { Wordmark } from '../brand/Wordmark';
import { Reveal, stagger } from '../motion/Reveal';
import { DoodleBurst } from '../brand/Doodles';
import { brandDescriptor } from '../../data/brandAssets';
const pillars = [{
  title: 'Bring In',
  copy: 'Welcome students and help them encounter the Gospel in a genuine Christian community.'
}, {
  title: 'Build Up',
  copy: 'Help students grow in faith, friendship, service, and leadership.'
}, {
  title: 'Send Out',
  copy: 'Equip students to live out their faith and serve on campus and beyond.'
}];
export function Mission() {
  return <Section className="on-dark relative overflow-hidden bg-brand-navy py-16 text-white sm:py-24" labelledBy="mission-heading" data-id="element-194" data-mp="3cp4w30y78ueq">
      <DoodleBurst className="pointer-events-none absolute right-8 top-10 h-12 w-12 opacity-80 sm:h-16 sm:w-16" color="var(--bcm-yellow)" data-id="element-195" data-mp="3qpz61o0wb3fi" />
      <Container data-id="element-196" data-mp="3k12dpryeeu15">
        <Reveal data-id="element-197" data-mp="3k1lwtbzsbogr">
          <p className="font-meta text-xs font-semibold uppercase tracking-[0.2em] text-brand-blue" data-id="element-198" data-mp="3k1u7qycckjpb">
            Our Mission
          </p>
          <h2 id="mission-heading" className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-6xl" data-id="element-199" data-mp="3p1zx27v59u48">
            Bring in. Build up. Send out.
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-8 sm:grid-cols-3 sm:gap-10" data-id="element-200" data-mp="6t9341aohjvf">
          {pillars.map((pillar, index) => <Reveal key={pillar.title} as="li" delay={stagger(index)} className="border-t-4 border-brand-yellow pt-5" data-id="element-201" data-mp="bs2ffqe8b4u0" data-mpi={index}>
              <h3 className="font-display text-2xl font-bold text-brand-blue" data-id="element-202" data-mp="li58trp9iksv">{pillar.title}</h3>
              <p className="mt-2 font-sans text-[16px] leading-relaxed text-white" data-id="element-203" data-mp="plteu5y8x8c0">{pillar.copy}</p>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} data-id="element-204" data-mp="uhijgnp4hff6">
          <div className="mt-14" data-id="element-205" data-mp="2qmhvthni7nta">
            {/* Supplied artwork on a light brand plate — never recolored. */}
            <Wordmark onDark className="h-8" data-id="element-206" data-mp="2mm7h9glnbp2t" />
            <p className="mt-3 font-meta text-[12px] font-medium uppercase tracking-[0.16em] text-brand-blue" data-id="element-207" data-mp="2mjbi5oy2aucs">
              {brandDescriptor}
            </p>
          </div>
        </Reveal>
      </Container>
    </Section>;
}